import { render } from "./Cohort.vue?vue&type=template&id=10af5044"
import script from "./Cohort.vue?vue&type=script&lang=js"
export * from "./Cohort.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__